export default __webpack_public_path__ + "static/media/bell.ff7030f7.svg";